import React from 'react';
import { PopoverButton } from './';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ColumnVisibility = ({
  tableManager,
  columns = tableManager.columnsApi.columns,
  onChange = tableManager.columnsVisibilityApi.toggleColumnVisibility
}) => {
  const {
    config: {
      additionalProps: {
        columnVisibility: additionalProps = {}
      },
      texts: {
        columnVisibility: columnVisibilityText
      },
      icons: {
        columnVisibility: columnVisibilityIcon
      }
    }
  } = tableManager;
  return /*#__PURE__*/_jsx(PopoverButton, {
    title: columnVisibilityText,
    buttonChildren: columnVisibilityIcon,
    popoverChildren: columns.filter(column => column.label).map((column, idx) => /*#__PURE__*/_jsxs("div", {
      className: "rgt-clickable rgt-columns-manager-popover-row",
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: `checkbox-${idx}`,
        title: column.label,
        onClick: () => onChange(column.id),
        className: "rgt-clickable rgt-flex-child rgt-text-truncate",
        children: column.label
      }), /*#__PURE__*/_jsx("input", {
        id: `checkbox-${idx}`,
        className: "rgt-clickable",
        type: "checkbox",
        onChange: () => {},
        checked: column.visible !== false
      })]
    }, column.id)),
    ...additionalProps
  });
};

export default ColumnVisibility;